// TODO: Remove once react-bootstrap is upgraded to v3+ (drops defaultProps on
// function components) and react-overlays to v6+ (drops findDOMNode usage).
if (process.env.NODE_ENV === "development") {
  const origError = console.error;
  const suppressed = [
    "Support for defaultProps will be removed from function components",
    "findDOMNode is deprecated",
  ];
  console.error = (...args) => {
    if (
      typeof args[0] === "string" &&
      suppressed.some((s) => args[0].includes(s))
    ) {
      const stack = new Error().stack || "";
      if (stack.includes("node_modules")) return;
    }
    origError.apply(console, args);
  };
}

import * as Sentry from "@sentry/react";
import * as ActiveStorage from "@rails/activestorage";
import Rails from "@rails/ujs";

// FontAwesome - imports only icons we use (~100KB vs 5.6MB for all)
import "~/lib/fontawesome";
import { createBrowserHistory } from "history";

import initializePostHog from "../src/lib/posthog-init";
import initializeChatwoot from "../src/lib/chatwoot_loader";

// Init scripts that add global extensions
import "~/init/string"; // String.prototype.truncate
import "~/init/timezone"; // Timezone detection and cookie

import AppRouter from "../src/components/app_router";
import AttentionNeeded from "../src/components/attention_needed";
import BillingApp from "../src/components/billing_app";
// Import components that are mounted via react_component helper in Rails views
// Only components explicitly used in ERB templates need to be registered
import GlobalContainer from "../src/components/global_container";
import LeadRecruitingApp from "../src/components/lead_recruiting_app";
import Messages from "../src/components/messages";
import NavBar from "../src/components/navigation/nav_bar";
import Notifications from "../src/components/notifications";
import OnboardApp from "../src/components/onboard_app";
import StyleguideDatepicker from "../src/components/styleguide/Datepicker";
// Styleguide components (only loaded in development styleguide page)
import StyleguideHtmlEditor from "../src/components/styleguide/HtmlEditor";
import StyleguideSelect from "../src/components/styleguide/Select";
import AuthPage from "../src/components/users/AuthPage";
import AuthTooltip from "../src/components/users/AuthTooltip";

// This will initialize PostHog if the conditions are met
initializePostHog();

Rails.start();
ActiveStorage.start();

if (process.env.SHAKAPACKER_PUBLIC_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.SHAKAPACKER_PUBLIC_SENTRY_DSN,
    environment: process.env.SHAKAPACKER_PUBLIC_SENTRY_ENVIRONMENT,
    ignoreErrors: ["AbortError"],
  });
}

// Explicit component registry for react_ujs
// Only register components that are mounted via react_component helper in ERB templates
// This replaces require.context which would load ALL 692 components (~14MB)
const componentRegistry = {
  // Core layout components
  GlobalContainer,
  AppRouter,
  OnboardApp,
  AttentionNeeded,

  // Components used in layouts/react.html.erb
  Notifications,
  Messages,

  // Components used in billing/show.html.erb
  BillingApp,
  "navigation/nav_bar": NavBar,
  "users/AuthTooltip": AuthTooltip,
  "users/AuthPage": AuthPage,

  // Components used in landing_pages/*.html.erb
  LeadRecruitingApp,

  // Styleguide components used in styleguide/_forms.html.erb
  "styleguide/HtmlEditor": StyleguideHtmlEditor,
  "styleguide/Select": StyleguideSelect,
  "styleguide/Datepicker": StyleguideDatepicker,
};

const ReactRailsUJS = require("react_ujs");

// Custom getConstructor that uses our explicit registry
ReactRailsUJS.getConstructor = (name) => {
  const component = componentRegistry[name];
  if (!component) {
    console.warn(
      `Component "${name}" not found in registry. Add it to componentRegistry in application.js`,
    );
  }
  return component;
};

_lodash.mixin(require("lodash-inflection"));

require("bootstrap"); // Registers Bootstrap jQuery plugins ($.fn.modal, etc.)

window.Cookies = require("js.cookie");

// Set components on window for global access
window.GlobalContainer = GlobalContainer;
window.AppRouter = AppRouter;
window.BillingApp = BillingApp;
window.OnboardApp = OnboardApp;
window.Notifications = Notifications;
window.Messages = Messages;
window.AttentionNeeded = AttentionNeeded;
window.LeadRecruitingApp = LeadRecruitingApp;
window.browserHistory = createBrowserHistory();
window.initializeChatwoot = initializeChatwoot;
if (window.brokerkitChatwootConfig) {
  initializeChatwoot(window.brokerkitChatwootConfig);
}

window.height = "auto";
